import { FC } from 'react';
import { Collapse } from '../../../../../../components/collapse/collapse';
import { UserRole } from '../../../../../../store/api/manager-api';
import { adminRecord } from '../../../cabinet/company-settings/company-admins/helpers';
import s from './roles-dictionary-admins.module.css';
import {
  RolesDictionaryAdminsProps,
  useRolesDictionaryAdmins,
} from './use-roles-dictionary-admins';

export const RolesDictionaryAdmins: FC<RolesDictionaryAdminsProps> = (props) => {
  const { t, getLocale, collapse, toggleCollapse } = useRolesDictionaryAdmins();

  const { role, admins } = props;

  return (
    <Collapse
      wrapperClassname={s.feature}
      withArrow
      headerClassName={s.trigger}
      open={collapse}
      onClickHeader={toggleCollapse}
      motionKey={role}
      key={role}
      header={
        <>
          <span className={s.name}>{t(adminRecord[role as UserRole])}</span>
          <span className={s.counter}>{`(${admins.length} ${t('сотрудник', {
            count: admins.length,
          })})`}</span>
        </>
      }
    >
      <ul className={s.employees}>
        {admins?.map((item) => (
          <li key={item.id} className={s.item}>
            {getLocale(item.name)} {getLocale(item.surname)}
          </li>
        ))}
      </ul>
    </Collapse>
  );
};
